<template>
  <div class="box">
    <logout></logout>
  </div>
</template>

<script>
import Logout from "@/components/microcomponents/Logout.vue";

export default {
  name: "SettingsContents",
  components: {
    logout: Logout
  }
};
</script>
